import selectors from 'store/selectors'
import projectActions from 'store/modules/project'
import clientActions from 'store/modules/client'
import quoteActions from 'store/modules/quote'
import resourceActions from 'store/modules/resource'

const authHandlers = {
  guest: (state) => selectors.user.loggedIn(state) ?
    'home' :
    null,
  user: (state) => selectors.user.loggedIn(state) ?
    null :
    'login',
}

const routes = [
  {
    name: 'login',
    path: '/login',
    authorize: authHandlers.guest,
  },
  {
    name: 'home',
    path: '/',
    authorize: authHandlers.user,
    redirect: 'quote',
  },
  {
    name: 'payment',
    path: '/payment',
    authorize: authHandlers.user,
  },
  {
    name: 'notfound',
    path: '/notfound',
  },
  {
    name: 'project',
    path: '/project',
    redirect: 'project.list',
    authorize: authHandlers.user,
    children: [
      {
        name: 'list',
        path: '/list',
        trigger: {
          activate: (store) => store.dispatch(projectActions.list()),
        },
      },
      {
        name: 'edit',
        path: '/edit/:id',
        trigger: {
          activate: (store, params) => store.dispatch(projectActions.get(params.id)),
        },
      },
    ]
  },
  {
    name: 'client',
    path: '/client',
    redirect: 'client.list',
    authorize: authHandlers.user,
    children: [
      {
        name: 'list',
        path: '/list',
        trigger: {
          activate: (store) => store.dispatch(clientActions.list()),
        },
      },
      {
        name: 'edit',
        path: '/edit/:id',
        trigger: {
          activate: (store, params) => store.dispatch(clientActions.get(params.id)),
        },
      },
    ]
  },
  {
    name: 'quote',
    path: '/quote',
    redirect: 'quote.list',
    authorize: authHandlers.user,
    children: [
      {
        name: 'list',
        path: '/list',
        trigger: {
          activate: (store) => {
            store.dispatch(clientActions.list())
            store.dispatch(quoteActions.list())
          },
        },
      },
      {
        name: 'create',
        path: '/create',
        trigger: {
          activate: (store) => {
            store.dispatch(clientActions.list())
          }
        },
      },
      {
        name: 'export',
        path: '/export/:id',
        disableToolbar: true,
        trigger: {
          activate: async (store, params, fromParams) => {
            // only reload the quote if it's a new id
            if(params.id != fromParams.id) {
              await store.dispatch(clientActions.list())
              await store.dispatch(quoteActions.get(params.id))
              // store.dispatch(quoteActions.setExpandedChildren({
              //   id: 'root',
              //   value: true,
              // }))
            }
          },
        },
      },
      {
        name: 'export_materials',
        path: '/export/materials/:id',
        disableToolbar: true,
        trigger: {
          activate: async (store, params, fromParams) => {
            // only reload the quote if it's a new id
            if(params.id != fromParams.id) {
              await store.dispatch(clientActions.list())
              await store.dispatch(quoteActions.get(params.id))
              store.dispatch(quoteActions.setExpandedChildren({
                id: 'root',
                value: true,
              }))
            }
          },
        },
      },
      {
        name: 'export_hire',
        path: '/export/hire/:id',
        disableToolbar: true,
        trigger: {
          activate: async (store, params, fromParams) => {
            // only reload the quote if it's a new id
            if(params.id != fromParams.id) {
              await store.dispatch(clientActions.list())
              await store.dispatch(quoteActions.get(params.id))
              store.dispatch(quoteActions.setExpandedChildren({
                id: 'root',
                value: true,
              }))
            }
          },
        },
      },
      {
        name: 'edit',
        path: '/edit/:id',
        trigger: {
          activate: (store, params, fromParams) => {
            // only reload the quote if it's a new id
            if(params.id != fromParams.id) {
              store.dispatch(clientActions.list())
              store.dispatch(quoteActions.get(params.id))
            }
          },
        },
        children: [
          {
            name: 'details',
            path: '/details',
          },
          {
            name: 'materials',
            path: '/materials',
          },
          {
            name: 'hire',
            path: '/hire',
          },
          {
            name: 'folder',
            path: '/folder/:folderid',
            children: [{
              name: 'tasks',
              path: '/tasks',
            }],
          },
          {
            name: 'notes',
            path: '/notes',
          }
        ],
      },
    ]
  },
  {
    name: 'resource',
    path: '/resource/:section',
    authorize: authHandlers.user,
    trigger: {
      activate: (store) => {
        store.dispatch(resourceActions.loadTree())
      },
    },
    children: [
      {
        name: 'list',
        path: '/list/:parentid',
        disableTreeScroll: true,
        trigger: {
          activate: (store, params) => {
            store.dispatch(resourceActions.setList([]))
            store.dispatch(resourceActions.loadList({
              section: params.section,
              parentid: params.parentid,
            }))
          }
        },
      },
      {
        name: 'edit',
        path: '/edit/:parentid/:type/:id',
        trigger: {
          activate: (store, params) => {
            store.dispatch(resourceActions.get(params.id))
          }
        },
      },
    ]
  },
]


export default routes